import React, { useState, useEffect } from "react";
import ProfileBar from "./components/ProfileBar";
import PageTitle from "./components/PageTitle";
import PageBar from "./components/PageBar";
import {
  Button,
  Grid,
  Icon,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import dayjs from "dayjs";
import { currentFormat, fetchData } from "./js/main";
import LinearProgress from "@mui/material/LinearProgress";

function getBills(form) {
  return new Promise(async (resolve) => {
    let fromDate = moment(form.fromDate).format("YYYY-MM-DD");
    let toDate = moment(form.toDate).format("YYYY-MM-DD");
    fromDate += "T00:00+07:00";
    toDate += "T24:00+07:00";
    const match = {
      $and: [
        { transactionDateandTime: { $gte: fromDate } },
        { transactionDateandTime: { $lte: toDate } },
      ],
    };
    let options = {
      skip: form.skip,
      limit: form.limit,
      sort: form.sort,
    };
    if (form.keyword) {
      options = {
        ...options,
        keyword: form.keyword,
      };
    } else {
      options = {
        ...options,
        match,
      };
    }
    let Bills = await fetchData("post", "/v3/bill/report", options);
    resolve(Bills);
  });
}

const limit = 100;

export default function RptRepository(props) {
  const [form, setForm] = useState();
  const [bills, setBills] = useState();
  const [loading, setLoading] = useState(true);
  const [pageCount, setPageCount] = useState(1);
  const [pageNo, setPageNo] = useState(1);
  useEffect(() => {
    if (props.profile) {
      const dt = new Date();
      setForm({
        fromDate: dt,
        // fromDate: new Date("2023-12-07"),
        toDate: dt,
        skip: 0,
        limit: limit,
        sort: { transactionDateandTime: -1 },
      });
    }
  }, [props]);
  useEffect(() => {
    (async () => {
      if (form) {
        setLoading(true);
        let bills = await getBills(form);
        setBills(bills);
        setLoading(false);
      }
    })();
  }, [form]);

  useEffect(() => {
    if (bills) {
      let count = Math.ceil(bills.count / limit);
      if (count < 1) count = 1;
      setPageCount(count);
    }
  }, [bills]);

  function goSearch(e) {
    const value = e.target.value.trim();
    let newForm = JSON.parse(JSON.stringify(form));
    if (value !== "") {
      newForm.keyword = {
        value: value,
        fields: ["bill_id", "payer.name", "operator.usn"],
      };
      newForm.skip = 0;
    } else {
      delete newForm.keyword;
    }
    setForm(newForm);
  }

  function changePage(no) {
    let skip = (no - 1) * limit;
    setForm({ ...form, skip });
    setPageNo(no);
  }
  return (
    <div className="content">
      <ProfileBar profile={props.profile} />
      <PageTitle page={props.page} />
      {form && (
        <>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid container spacing={2} sx={{ marginTop: "15px" }}>
              <Grid item xs={12} md={3} lg={2}>
                <DatePicker
                  format="DD MMM YYYY"
                  onChange={(newValue) =>
                    setForm({ ...form, fromDate: new Date(newValue) })
                  }
                  label="Form Date"
                  value={dayjs(form.fromDate)}
                  slotProps={{
                    textField: {
                      InputLabelProps: { shrink: true },
                      fullWidth: true,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3} lg={2}>
                <DatePicker
                  format="DD MMM YYYY"
                  onChange={(newValue) =>
                    setForm({ ...form, toDate: new Date(newValue) })
                  }
                  label="To Date"
                  value={dayjs(form.toDate)}
                  slotProps={{
                    textField: {
                      InputLabelProps: { shrink: true },
                      fullWidth: true,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={8} align="right">
                <TextField
                  variant="outlined"
                  sx={{ maxWidth: "350px" }}
                  fullWidth
                  InputProps={{
                    endAdornment: <Icon>search</Icon>,
                  }}
                  label="Search"
                  placeholder="Keyword..."
                  InputLabelProps={{ shrink: true }}
                  onKeyUp={(e) => e.key === "Enter" && goSearch(e)}
                />
              </Grid>
            </Grid>
          </LocalizationProvider>
          <br />
        </>
      )}
      {bills && (
        <>
          <div style={{ fontSize: "1rem" }} className="bold">
            Result : {bills.count} bill(s)
          </div>
          <div style={{ margin: "5px auto 15px" }}>
            <PageBar
              onChangePage={changePage}
              count={pageCount}
              pageNo={pageNo}
            />
          </div>
          <BillTable bills={bills} skip={form.skip} loading={loading} />
        </>
      )}
    </div>
  );
}

function BillTable({ bills, skip, loading }) {
  return (
    <div>
      {loading === true && <LinearProgress />}
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: "60px" }}>No</TableCell>
              <TableCell>Bill Date</TableCell>
              <TableCell>Bill No</TableCell>
              <TableCell>Payer Name</TableCell>
              <TableCell>Operator</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Remark</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bills.count === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={7}
                  sx={{ lineHeight: "60px", color: "#888" }}
                  align="center"
                >
                  No bill found
                </TableCell>
              </TableRow>
            ) : (
              <>
                {bills.result.map((bill, key) => (
                  <TableRow hover key={key}>
                    <TableCell align="center">{key + skip + 1}</TableCell>
                    <TableCell align="center">
                      {moment(bill.transactionDateandTime).format(
                        "DD MMM YYYY, HH:mm"
                      )}
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        onClick={() =>
                          window.open(
                            process.env.PUBLIC_URL + "/bill/" + bill.bill_id
                          )
                        }
                        sx={{
                          lineHeight: "15px",
                          padding: "3px 3px",
                        }}
                      >
                        {bill.bill_id}
                      </Button>
                    </TableCell>
                    <TableCell>{bill.payerName}</TableCell>
                    <TableCell>
                      {bill.operator && (
                        <>
                          {bill.operator.name &&
                          bill.operator.name.indexOf("undefined") < 0 ? (
                            <>{bill.operator.name}</>
                          ) : (
                            <>{bill.operator.usn}</>
                          )}
                        </>
                      )}
                    </TableCell>
                    <TableCell align="right">
                      {currentFormat(bill.amount)}
                    </TableCell>
                    <TableCell align="center" className="inputPadding">
                      {bill.canceled.status === true && (
                        <>
                          <span style={{ color: "#f00" }}>ยกเลิก</span>
                          <div style={{ fontSize: ".7rem", color: "#888" }}>
                            {bill.canceled.usn}
                          </div>
                        </>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
